export default __webpack_public_path__ + "6cf7de810f8b1252b30624f0c761d53a.png";